<template>
  <v-card class="content column" max-width="960" flat>
    <v-toolbar height="72" flat color="secondary">
      <v-breadcrumbs :items="breadcrumbs" divider=">" large class="pa-0 ma-0" dark>
        <v-breadcrumbs-item
          slot="item"
          slot-scope="{ item }"
          exact
          :to="{ path: item.href, query: item.query }">
          <v-icon v-if="item.icon" size="24" color="white">
            {{ item.icon }}
          </v-icon>
          <div class="text-body-2 font-weight-bold white--text" color="white">
            {{ item.text }}
          </div>
        </v-breadcrumbs-item>
      </v-breadcrumbs>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container class="row ma-0 px-2" style="height: 80%; width: 100%;">
      <v-list dense>
        <v-list-item v-for="(item, i) in contents" :key="i" @click="openLink(item)">
          <v-list-item-action class="pl-2 mr-4 my-0">
            <v-icon size="24" class="pa-0">{{icon(item.type)}}</v-icon>
          </v-list-item-action>
          <v-list-item-content class="text-body-2"
          ><span v-html="item.title"></span></v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
  </v-card>
</template>

<script>
const root = {
  text: '',
  icon: 'mdi-home',
  href: '/activities',
  id: 0,
  query: null,
};

export default {
  name: 'Activities',
  methods: {
    icon(type) {
      return type === 1 ? 'mdi-folder-outline' : 'mdi-file-pdf';
    },
    openLink(item) {
      if (item.type === 1) {
        const url = `/activities/${item.id}`;
        const breadcrumb = {
          text: item.title,
          href: url,
          id: item.id,
        };
        this.breadcrumbs.push(breadcrumb);
        this.breadcrumbs[this.breadcrumbs.length - 1].query = this.query;
        this.$router.push({ path: url, query: this.query });
      } else {
        const url = `https://services.beyondlabz.com/client_assets/worksheets/${item.id}.pdf`;
        window.open(url, '_blank');
      }
    },
    updateFolderContents() {
      this.contents = [];
      this.showProgress = true;
      const parentId = this.$route.params.activity || 0;
      const url = `https://portal.beyondlabz.com/worksheets/list/${parentId}`;
      this.$http.get(url)
        .then((resp) => {
          if (resp.status === 200) {
            this.showProgress = false;
            this.contents = resp.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateBreadcrumbs() {
      const activityIds = this.$route.query.ids;
      const activityNames = this.$route.query.names;
      const breadcrumbs = [root];
      if (activityNames) {
        activityNames.forEach((name, index) => {
          const activityId = activityIds[index];
          const breadcrumb = {
            text: name,
            id: activityId,
            href: `/activities/${activityId}`,
            query: {
              ids: activityIds.slice(0, index + 1),
              names: activityNames.slice(0, index + 1),
            },
          };
          breadcrumbs.push(breadcrumb);
        });
      }
      this.breadcrumbs = breadcrumbs;
    },
  },
  data: () => ({
    breadcrumbs: [root],
    routeQuery: {},
    contents: [],
    showProgress: false,
  }),
  computed: {
    query() {
      const ids = [];
      const names = [];
      this.breadcrumbs.slice(1).forEach((item) => {
        ids.push(item.id);
        names.push(item.text);
      });
      return ids ? { ids, names } : null;
    },
  },
  watch: {
    $route() {
      this.updateBreadcrumbs();
      this.updateFolderContents();
    },
  },
  mounted() {
    this.updateFolderContents();
    this.updateBreadcrumbs();
  },
};
</script>

<style scoped>
.page {
  width: 100%;
  padding: 50px;
}
.content {
  width: 100%;
  min-height: 312px;
  min-width: 480px;
}
.buttons {
  flex-direction: column;
}
.content-lower {
  flex-direction: row;
  height: 100%;
}
</style>
